import { connect } from 'react-redux';
import HallMarksView from './hallmarks-view';

function mapStateToProps(state) {
  return {
    idPlant: state.rootReducer.idPlant,
    idObject: state.rootReducer.idObject,
    hallmarks: state.rootReducer.hallmarks,
    comments: state.rootReducer.comments,
    modelCode: state.rootReducer.modelCode
  };
}

export default connect(mapStateToProps)(HallMarksView);



/** WEBPACK FOOTER **
 ** app/components/docs-hallmarks/view/hallmarks-container.js
 **/